import {Api} from '../api/api';
import {ReadyProvider} from '../providers/readyProvider';

class LazyCookieMessage
{
    static load() {
        let cookieMessageElement = document.querySelector('[data-content="cookie-message"]');

        if (!cookieMessageElement) {
            return;
        }

        if (localStorage.getItem('check_cookie') !== null) {
            return;
        }

        let lazyLoad = cookieMessageElement.getAttribute('data-load') === 'lazy';

        if (lazyLoad) {
            ReadyProvider.executeWithLazy(() => {
                this._lazyLoad(cookieMessageElement);
            });
        } else {
            this._show(cookieMessageElement);
        }
    }

    static _lazyLoad(cookieMessageElement) {
        Api.post(cookieMessageElement.getAttribute('data-endpoint'), {}, (response) => {
            if (response.isFailure()) {
                return;
            }

            cookieMessageElement.innerHTML = response.get('content', '');
            this._show(cookieMessageElement);
        });
    }


    static _show(cookieMessageElement) {
        cookieMessageElement.style.display = 'block';
        cookieMessageElement.querySelector('[data-cookie="close"]').addEventListener('click', () => {
            localStorage.setItem('check_cookie', '1');
            cookieMessageElement.remove();
        });
    }
}

export {LazyCookieMessage};
